import StatusChip from 'components/@extended/StatusChip.tsx';
import { t } from 'utils/getTranslations';

/** Marks a Draft experience record wherever it is listed or opened: it still awaits review. */
export const XrDraftChip = ({ className }: { className?: string }) => (
    <StatusChip type="warning" label={t('experience-records.status.DRAFT')} className={className} />
);
